export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/PythonWorker.worker.b1732727.js");
}
